import {
	FETCH_PATIENTS_LIST_REQUEST,
	FETCH_PATIENTS_LIST_SUCCESS,
	FETCH_PATIENTS_LIST_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const patientListsReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PATIENTS_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_PATIENTS_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case FETCH_PATIENTS_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default patientListsReducer